import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Image from "../../../../Elements/Image/Image";
import Button from "../../../../Elements/Button/Button";
import { memo } from "react";
import { LinkToNewTab } from "../../../../Elements/Link/Link";

import styles from "./styles.module.scss";

const BrandingSection = memo(() => {
  const { getTextByKey, getHtmlByKey } = useContent();

  return (
    <div className={styles.brandingWrapper}>
      <div className={styles.anchorElem} id="branding-title" />
      <h2 id="download-page-title">{getTextByKey("branding-title")}</h2>
      <p>{getHtmlByKey("branding-description-1")}</p>
      <p>{getHtmlByKey("branding-description-2")}</p>
      {/*@ts-ignore*/}
      <LinkToNewTab page="user/branding/cover-logo">
        <Button className={styles.learnMoreButton}>
          {getTextByKey("learn-more")}
        </Button>
      </LinkToNewTab>
      <Image name="features/branding_img" ext="png" />
    </div>
  );
});

export default BrandingSection;
